window.Sparkle ??= {};

window.Sparkle.Utilities = window.Sparkle.Utilities || {};
